<template>
  <v-row justify="center">
    <v-dialog v-model="bMostrar" persistent max-width="655px">
      <v-progress-linear
        v-if="cargando"
        indeterminate
        color="titlesdark darken-2"
      />
      <v-card>
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer />
          <span class="mdlHeadForms">{{
            oEquivalencias.ttlAgregarObservacion
          }}</span>
          <v-spacer />
          <v-btn
            color="btncolor-dark"
            @click="bMostrar = false"
            icon
            small
            dark
            outlined
          >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <span class="ntitlesdark--text">{{
                  oEquivalencias.lblAccion
                }}</span>
                <v-autocomplete
                  class="mt-1"
                  v-model="accion"
                  :items="aAcciones"
                  item-text="texto"
                  item-value="id"
                  placeholder="Seleccione"
                  height="30px"
                  clearable
                  outlined
                  dense
                  :alt="'cmp-select-accion'"
                  hide-details
                >
                  <template slot="no-data">
                    <div>No hay información</div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <FormTextoArea
                  v-model="sComentario"
                  :titulo="oEquivalencias.cmpComentario"
                  :editable="'1'"
                  :sPlaceHolder="oEquivalencias.plhComentario"
                  :obligatorio="true"
                />
              </v-col>
              <v-col cols="12">
                <span class="titleslight--text">
                  {{ oEquivalencias.lblAnexos }}
                </span>
                <DragUpdateFile
                  :key="nKeyDragFile"
                  @files="f_anexos"
                  :NoAnexos="10"
                  :MaxTamanoFile="1048576 * 50"
                ></DragUpdateFile>
              </v-col>
              <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
                <v-row justify="center" align="center" class="pa-4">
                  <v-btn class="no-uppercase d-flex mx-2" large depressed dark color="primary" @click="bMostrar = false" outlined rounded>
                    {{ oEquivalencias.btnCancelar }}
                  </v-btn>
                  <v-btn class="no-uppercase d-flex mx-2" large depressed dark color="primary" @click="onGuardar()" :loading="cargando" rounded>
                    {{ oEquivalencias.btnGuardar }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ErrorView v-model="bMostrarErrores" :aErrores="aErrores"></ErrorView>
  </v-row>
</template>
    <script>
import axiosServices from "@/services/axiosServices.js";
import FormTextoArea from "@/components/Form/Componentes/FormTextArea.vue";
import DragUpdateFile from "@/components/DragUpdateFile.vue";
import ErrorView from "@/components/ErrorView.vue";
import mxFunciones from "@/mixins/funciones.js";
import { mapGetters } from 'vuex'

export default {
  mixins: [mxFunciones],
  components: {
    FormTextoArea,
    DragUpdateFile,
    ErrorView,
  },
  name: "EditarTicketModal",
  props: {
    sTable: {
      type: String,
    },
    sTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cargando: false, // empleada para indicar que el form esta cargando
      Mensaje: "Cargando..",
      bMostrar: false,
      bDisabled: false,
      idRequerimiento: 0,
      nKeyDragFile:0,
      aAnexos: [],
      sComentario: "",
      bMostrarErrores: false,
      aErrores: [],
      // propiedades del autocomplete
      aAcciones: [
        { id: 2, texto: "No conformidad" },
        { id: 4, texto: "Cerrar ticket" },
      ],
      accion: null,
      oEquivalencias: this.$store.state.jsIdioma.oEquivalencias,
    };
  },
  mounted() {
  },
  methods: {
    f_anexos(files) {
      this.aAnexos = files;
    },
    limpiarCampos() {
      this.showDobleSelect = false;
      this.department = "";
    },
    onInit() {
      this.accion = null;
      this.sComentario = "";
      this.cargando = false;
      this.aAnexos=[];
      this.aErrores=[];
      this.nKeyDragFile++
    },
    FormatAnexos() {
      let aGaleria = [];
      // recorro los Anexos para sacar todos los nombres de las anexos que tenga y dejarlos como [ {Foto : "NombreArchico"}]
      this.aAnexos.forEach(Anexos => {
        if(Anexos) {
          aGaleria.push({ 
            Foto : Anexos.name,
            TipoAnexo: Anexos.type.includes("image") ? "1" : "2",
          })
        }
      });

      return aGaleria;
    },
    async onGuardar() {
      this.cargando = true;
      this.onValidarCampos();
      // Valido que bMostrarErrores siga en falso
      if (this.bMostrarErrores) {
        this.cargando = false;
        return;
      }
      const oBody = {
        accion: this.accion,
        comentario: `${this.sComentario}\n ---Usuario externo:${this.$store.state.sNombreUsuario}`,
        fotos: this.FormatAnexos(),
        idRequerimiento: this.idRequerimiento,
      };

      const { nStatusCode, sMessage } = await axiosServices.postConfiguration(
        "/pqr_addobservacion",
        oBody,
        true
      );
      if (nStatusCode == 200 || nStatusCode == 220) {
        this.onSubirAnexos(this.aAnexos);
        this.$store.dispatch("notificaciones/SetMensaje", sMessage);
        this.$store.dispatch("notificaciones/SetColor", "success");
        this.$store.dispatch("notificaciones/ShowNotificacion", true);
        this.cargando = false;
        this.$emit("onCerrarAgregar", true);
      } else {
        this.cargando = false;
        this.$store.dispatch("notificaciones/SetMensaje", sMessage);
        this.$store.dispatch("notificaciones/SetColor", "error");
        this.$store.dispatch("notificaciones/ShowNotificacion", true);
      }
    },
    onValidarCampos() {
      this.aErrores = [];
      this.bMostrarErrores = false;
      if (this.sComentario === "" || this.sComentario === null)
        this.aErrores.push("Debe agregar un comentario");
      if (this.accion === "" || this.accion === null)
        this.aErrores.push("Debe seleccionar una acción");
      this.bMostrarErrores = this.aErrores.length > 0;
    },
  },
  computed: {
		...mapGetters("detalle", ['getsNombreUsuario'])
	},
};
</script>